module.exports = __webpack_public_path__ + "img/juegosbg.9dacf7b0.jpg";